import {styled} from '@mui/material'
import React from 'react'
import {colors} from '../../constants/colors'

const CloseIcon = ({ color, size = 32 }: { color?: string; size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 32 32`}
    fill="none"
  >
    <StyledPath
      d="M25 7L7 25M7 7L25 25"
      strokeColor={color}
      stroke-width="2px"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

const StyledPath = styled('path')<{strokeColor?: string}>`
  ${({theme, strokeColor}) => `
    stroke: ${
  strokeColor != null ? strokeColor : theme.palette.mode == 'dark'
        ? colors.DARK_MODE_10
        : colors.BLACK_100
    };
  `}
`

export default CloseIcon
